import { MemorySearchSettings } from '../memory-search-client/memory-search-client';

export interface WikiTreeSourceSettings extends MemorySearchSettings {
  type: 'wiki-tree';
  wikiId: string;
  searchView?: boolean;
  stateView?: boolean;
}
